<template>
    <div class="plugin-list">
        <pay-box title="已开通应用" padding="24px 18px">
            <div class="plugin-box">
                
                <div class="plugin-item" @click="toDetail">
                    <div class="plugin-content">
                        <div class="plugin-icon">
                            <img src="/assets/images/plugin-icon/green.png">
                        </div>
                        <div class="plugin-name">
                            AI系统应用技术
                        </div>
                        <div class="plugin-period">使用期限：2023.03.29-2024.03.29</div>
                        <div class="plugin-desc">
                            <span>如想继续使用，请联系客服购买，电话</span>
                            <span>13888888888</span>
                        </div>
                        <div class="line"></div>
                        <div class="enter">
                            <span>进入</span>
                            <img src="/assets/images/plugin-icon/right.png">
                        </div>
                    </div>
                    <div class="bg-icon"></div>
                </div>

                <div class="plugin-item">
                    <div class="plugin-content">
                        <div class="plugin-icon">
                            <img src="/assets/images/plugin-icon/orange.png">
                        </div>
                        <div class="plugin-name">
                            AI系统应用技术
                        </div>
                        <div class="plugin-period">使用期限：2023.03.29-2024.03.29</div>
                        <div class="plugin-desc">
                            <span>距离过期还剩</span>
                            <span>30</span>
                            <span>天，请尽快续费。</span>
                        </div>
                        <div class="line"></div>
                        <div class="enter">
                            <span>进入</span>
                            <img src="/assets/images/plugin-icon/right.png">
                        </div>
                    </div>
                    <div class="bg-icon"></div>
                </div>

                <div class="plugin-item">
                    <div class="plugin-content">
                        <div class="plugin-icon">
                            <img src="/assets/images/plugin-icon/blue.png">
                        </div>
                        <div class="plugin-name">
                            AI系统应用技术
                        </div>
                        <div class="plugin-period">使用期限：2023.03.29-2024.03.29</div>
                        <div class="plugin-desc">
                            <span>距离过期还剩</span>
                            <span>30</span>
                            <span>天，请尽快续费。</span>
                        </div>
                        <div class="line"></div>
                        <div class="enter">
                            <span>进入</span>
                            <img src="/assets/images/plugin-icon/right.png">
                        </div>
                    </div>
                    <div class="bg-icon"></div>
                </div>
            </div>
        </pay-box>
        <pay-box title="待开通应用">
            <div class="plugin-box">
                
                <div class="plugin-item">
                    <div class="plugin-content">
                        <div class="plugin-icon">
                            <img src="/assets/images/plugin-icon/green.png">
                        </div>
                        <div class="plugin-name">
                            <span>基础版</span>
                            <span>(服务时间1年，数据保留1年，账号数5个)</span>
                        </div>
                        <div class="plugin-tips">2021年领先全国的技术，用过的人都说好2021年领先全国的技术，用过的人都说好2021年领先全国的技术，用过的人都说好</div>
                        <div class="line"></div>
                        <div class="enter">
                            <div class="price show">
                                <span>¥</span>
                                <span>3980.00</span>
                                <span>/年</span>
                            </div>
                            <div class="text">进入</div>
                            <img src="/assets/images/plugin-icon/right.png">
                        </div>
                    </div>
                    <div class="bg-icon"></div>
                </div>

            </div>
        </pay-box>
    </div>

</template>

<script>
import PayBox from "@/views/AST/Pay/Step/PayBox.vue";
export default {
    name: "PluginList",
    components: {
        PayBox
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
        toDetail() {
            this.$router.push({ name: 'pluginDetail', params: { id: 1 } })
        }
    }
}
</script>

<style scoped lang="less">
.plugin-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;

    .plugin-item {
        width: 316px;
        min-height: 211px;
        background: #FFFFFF;
        border: 1px solid transparent;

        position: relative;
        .plugin-content {
            width: 100%;
            height: 100%;
            box-shadow: 2px 2px 12px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            padding: 16px;
            padding-bottom: 48px;
            position: absolute;
            top: 0;
            left: 0;
        }
        .bg-icon {
            width: 100%;
            height: 100%;
            background: url('/assets/images/plugin-icon/bg-icon.png') no-repeat center center;
            background-size: cover;
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
        }
        
        .plugin-icon {
            width: 32px;
            display: flex;
            padding-top: 8px;

            img {
                width: 32px;
                height: 32px;
            }
        }

        .plugin-name {
            color: #333;
            font-size: 16px;
            font-weight: bold;
            margin-top: 12px;
            span{
                &:nth-child(2) {
                    font-size: 10px;
                    font-weight: 400;
                    margin-left: 4px;
                }
            }
        }

        .plugin-tips {
            color: #999;
            font-size: 12px;
            margin-top: 16px;
            line-height: 16px;
            // 超出2行部分省略号
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .plugin-period {
            color: #999;
            font-size: 12px;
            margin-top: 16px;
        }

        .plugin-desc {
            color: #333;
            font-size: 12px;
            margin-top: 8px;

            span {
                &:nth-child(2) {
                    color: #427AE8;
                }
            }
        }

        .line {
            width: 100%;
            height: 1px;
            background: #EEEEEE;
            margin-top: 10px;
        }

        .enter {
            width: 100%;
            color: #333;
            font-size: 14px;
            line-height: 48px;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            bottom: 0;
            left: 0;
            img{
                width: 16px;
                height: 16px;
            }
            .price {
                color: #355FEB;
                font-size: 12px;
                span {
                    &:nth-child(2) {
                        font-size: 18px;
                    }
                }
            }
            .text{
                display: none;
            }
        }

        &:hover {
            cursor: pointer;
            background: linear-gradient(180deg, #E8F0FA 0%, #FFFFFF 100%);
            border: 1px solid #3B66F4;
            .bg-icon {
                display: block;
            }
            
            .enter {
                color: #fff;
                background: #355FEB;
                .show {
                    display: none;
                }
                .text {
                    color: #fff;
                    background: #355FEB;
                    display: block;
                }
            }
        }
    }
}
</style>